//#region Asset Imports

import { $SCOPE_SERVICE_NAME } from '../../../services/system'
import { CONFIGURATION_PROFILE_SERVICE_NAME } from '../../../services/configuration-profile'
import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { IMRBaseComponent } from '../../common/base'
import { ConfigurationProfileScheduleController } from './configuration-profile-schedule.component.controller'

import * as TEMPLATE from './configuration-profile-schedule.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'configurationProfileSchedule'

export class ConfigurationProfileScheduleComponent extends IMRBaseComponent {
	constructor() {
		super({
			controller: ConfigurationProfileScheduleController,
			template: TEMPLATE,
			services: [USER_SESSION_SERVICE_NAME, CONFIGURATION_PROFILE_SERVICE_NAME, $SCOPE_SERVICE_NAME],
		})
	}
}
